var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "flex input-group" }, [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedOrderAccess.project,
              expression: "selectedOrderAccess.project",
            },
          ],
          staticClass: "custom-select",
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.selectedOrderAccess,
                "project",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            },
          },
        },
        [
          _c("option", { attrs: { value: "all" } }, [_vm._v("Все проекты")]),
          _vm._v(" "),
          _vm._l(_vm.$AllProjects, function (project) {
            return project.id
              ? _c("option", { domProps: { value: project.id } }, [
                  _vm._v(_vm._s(project.name)),
                ])
              : _vm._e()
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedOrderAccess.division,
              expression: "selectedOrderAccess.division",
            },
          ],
          staticClass: "custom-select",
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.selectedOrderAccess,
                "division",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            },
          },
        },
        [
          _c("option", { attrs: { value: "all" } }, [_vm._v("Все дивизионы")]),
          _vm._v(" "),
          _vm._l(_vm.$AllDivisions, function (div) {
            return _c("option", { domProps: { value: div.id } }, [
              _vm._v(_vm._s(div.title)),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-outline-success btn-sm",
          on: { click: _vm.addSelected },
        },
        [_vm._v("Добавить")]
      ),
    ]),
    _vm._v(" "),
    _vm.accessRecords && _vm.accessRecords.length > 0
      ? _c("div", { staticClass: "mt-2" }, [
          _c("table", { staticClass: "table table-sm table-hover" }, [
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v("Проект")]),
                _vm._v(" "),
                _c("th", [_vm._v("Направление")]),
                _vm._v(" "),
                _vm.visibilitySelect
                  ? _c("th", [_vm._v("Видимость")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.useCustomRate
                  ? _c("th", [_vm._v("Коэффициент")])
                  : _vm._e(),
                _vm._v(" "),
                _c("th"),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.accessRecords, function (record, index) {
                  return [
                    record.division_id
                      ? _c("tr", [
                          _c("td", { attrs: { width: "100" } }, [
                            _vm._v(
                              _vm._s(
                                record.project_id === "all"
                                  ? "Все проекты"
                                  : _vm.$AllProjects[record.project_id].name
                              ) + "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(record.divisionTitle))]),
                          _vm._v(" "),
                          _vm.visibilitySelect
                            ? _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: record.visibleForAgent,
                                      expression: "record.visibleForAgent",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      record.visibleForAgent
                                    )
                                      ? _vm._i(record.visibleForAgent, null) >
                                        -1
                                      : record.visibleForAgent,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = record.visibleForAgent,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              record,
                                              "visibleForAgent",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              record,
                                              "visibleForAgent",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(record, "visibleForAgent", $$c)
                                      }
                                    },
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.useCustomRate
                            ? _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: record.customRate,
                                      expression: "record.customRate",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: { value: record.customRate },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        record,
                                        "customRate",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { width: "70" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-xs btn-danger",
                                  on: {
                                    click: function ($event) {
                                      return _vm.remove(index)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "icon-fa icon-fa-remove text-center",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }